'use client'

import { Modal, ModalBody, ModalContent, ModalHeader } from '@nextui-org/react'

import { useRedeemT } from '../i18n/useRedeemT'
import SliderCaptcha from './SliderCaptcha'

interface Props {
  isOpen: boolean
  onClose: () => void
  onSolved: () => void
}

/**
 * Gate in front of verify, mirroring the legacy order: the form validates first, then the puzzle
 * opens. The `key` remounts `SliderCaptcha` per open, so re-opening gives a fresh image and hole
 * rather than resuming a half-dragged attempt.
 */
export default function CaptchaModal({ isOpen, onClose, onSolved }: Props) {
  const t = useRedeemT()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size='sm'
      placement='center'
      hideCloseButton={false}
      classNames={{ base: 'max-w-[328px]' }}>
      <ModalContent>
        <ModalHeader className='pb-2 text-sm font-bold text-gray-900'>
          {t('LABEL_CAPTCHA')}
        </ModalHeader>
        <ModalBody className='px-3 pb-6'>
          {isOpen && (
            <SliderCaptcha
              key={String(isOpen)}
              onSuccess={onSolved}
              labels={{
                bar: t('LABEL_CAPTCHA_SLIDE'),
                failed: t('ERROR_CAPTCHA_FAILED'),
                success: t('BUTTON_VERIFIED')
              }}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
